import { render, staticRenderFns } from "./tuwendaohang.vue?vue&type=template&id=07585ec4&scoped=true&"
import script from "./tuwendaohang.vue?vue&type=script&lang=js&"
export * from "./tuwendaohang.vue?vue&type=script&lang=js&"
import style0 from "./tuwendaohang.vue?vue&type=style&index=0&id=07585ec4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07585ec4",
  null
  
)

export default component.exports